export const colors = {
  primary: '#F07E31',
  secondary: '#4983ef',

  danger: '#D83430',
  success: '#59BC5C',
  info: '#3E81F7',

  red: '#ec4329',

  mineShaft: '#1F1F1F',

  macaroniAndCheese: '#FEBE83',

  regalBlue: '#003B76',
  oldBrick: '#92271A',

  blue: '#3e81f7',
  blueDark: '#3D578E',
  blueLight2: '#f6f9ff',
  blueLight: '#F8FBFF',
  cornflowerBlue: '#6195ED',
  tropicalBlue: '#B9D1F8',

  transparent: 'transparent',

  white: '#FFFFFF',
  zircon: '#f6f9ff',
  zircon2: '#EDF3FF',
  alto: '#e0e0e0',
  alto2: '#DAD9D9',
  alto3: '#DEDEDE',
  silverChalice: '#9e9e9e',
  serenade: '#FFF3E9',

  alabaster: '#F7F7F7',
  alabaster2: '#FBFBFB',
  alabaster3: '#FCFCFC',
  greyLighter: '#EEEEEE',
  mercury: '#E5E5E5',
  greyLighter2: '#DCDCDC',
  greyLight: '#CBCBCB',
  greyMedium: '#A1A1A1',
  greyDark: '#565656',
  grey2: '#737373',
  grey: '#6D6D6D',

  greySilver: '#C4C4C4',

  opaque: '#FFCB9E',
  salmon: '#F57F7C',

  green: '#59bc5c',
  heart: '#d41f1f',
};
